import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Locale from 'src/Locale';
import UserAccount from 'src/components/App/UserAccount';
import { loadColleaguePiRoles } from '../../services/UserService';
import * as core from 'cw-ui-core';

const UserAccountPi = props => {
    const { formatMessage } = props.intl;
    const { partnerId, userId } = props;

    const loadIdentityRoles = () => {
        if (!partnerId || !userId) {
            return;
        }
        loadColleaguePiRoles(partnerId, userId).catch(error => {
            core.CwLog.error(`Failed to load colleague PI roles. ${error}`);
        });
    };

    return (
        <UserAccount
            initials={props.initials}
            userName={props.userName}
            email={props.email}
            items={[{ id: 'logout', name: formatMessage(Locale.logout) }]}
            onMenuItemClick={props.onUserAccountItemClicked}
            onMenuOpen={loadIdentityRoles}
            userAppRoles={props.userAppRolesParsed}
            userFilteredIdentityRoles={props.filteredRoles}
        />
    );
};

const mapStateToProps = state => {
    const userName = core.getUserFirstName(state.oidc) + ' ' + core.getUserLastName(state.oidc);
    const email = core.getUserEmail(state.oidc);
    const name = core.getUserName(state.oidc);
    const partnerId = core.getPartnerId(state.oidc);
    const userId = core.getUserId(state.oidc);

    const matchingPiRoles = core.getModuleCache(state.module, ['matchingPiRoles']);
    let filteredRoles;
    if (matchingPiRoles === undefined) {
        filteredRoles = 'Processing your identity roles...';
    } else if (matchingPiRoles === '') {
        filteredRoles = 'No relevant identity roles assigned';
    } else {
        filteredRoles = matchingPiRoles;
    }

    const userAppRoles = core.getUser(state.oidc).getIn(['profile', 'app_role_assignments']);
    let userAppRolesList;
    if (userAppRoles) {
        userAppRolesList = typeof userAppRoles === 'string' || userAppRoles instanceof String ? [userAppRoles] : userAppRoles.toJS();
    }
    let userAppRolesParsed = Array.isArray(userAppRolesList)
        ? userAppRolesList
              .map(role => {
                  if (typeof role === 'object' && role !== null) {
                      return role.appRoleId || role.name || role.id || '';
                  }
                  return role;
              })
              .filter(Boolean)
              .join(', ')
        : typeof userAppRolesList === 'object' && userAppRolesList !== null
          ? userAppRolesList.appRoleId || userAppRolesList.name || userAppRolesList.id || ''
          : userAppRolesList;

    return {
        initials: core.getInitials(name),
        userName,
        email,
        userAppRolesParsed,
        filteredRoles,
        partnerId,
        userId,
    };
};

const mapDispatchToProps = () => {
    return {
        onUserAccountItemClicked: id => {
            switch (id) {
                case 'logout':
                    core.signoutRedirect();
                    break;

                default:
                    break;
            }
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserAccountPi));
